import { useLang } from '@/i18n';
import EFXGanPower from 'elem/ui-assets/icons/unregular/EFXGanPower';
import EfImg from 'elem/ui/ef-img';
import EfInfoSection from 'elem/ui/ef-info-section';
import EfSpec from 'elem/ui/ef-spec';
import { useEffect, useState } from 'react';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionE');
    const [enter, setEnter] = useState(false);

    const items = [
        {
            hour: t('a_text2'),
            text: t('a_text1'),
        },
        {
            hour: t('b_text2'),
            text: t('b_text1'),
        },
        {
            hour: t('c_text2'),
            text: t('c_text1'),
        },
        {
            hour: t('d_text2'),
            text: t('d_text1'),
        },
        {
            hour: t('e_text2'),
            text: t('e_text1'),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            AniContainer.create({
                triggerElement: `.${styles.TheComp} .info`,
                triggerHook: 1,
                offset: '30%',
                duration: '100%',
                onEnter: () => setEnter(true),
            });
        }
    }, []);

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <div className="logo">
                <EFXGanPower />
            </div>
            <EfInfoSection
                title={t('title')}
                desc={t.rich('desc', {
                    sup: (tx: string) => <sup>{tx}</sup>,
                })}
            />
            <div className="box">
                <div className="img">
                    <EfImg
                        pc={'https://websiteoss.ecoflow.com/upload/image/1739009656860/light.jpg'}
                        pad={'https://websiteoss.ecoflow.com/upload/image/1739009660249/light_m.jpg'}
                        // h5={'https://websiteoss.ecoflow.com/upload/image/1739009660249/light_m.jpg'}
                        h5={'https://websiteoss.ecoflow.com/upload/image/1739009656860/light.jpg'}
                    />
                </div>
                <div className="info">
                    <div className="info-inner">
                        <p className="inner-title">{t('con1')}</p>
                        <ul className="items">
                            {items?.map((item: any, k: number) => (
                                <li className={`item item-${k + 1}${enter ? ' enter' : ''}`} key={k}>
                                    <p className="bar"></p>
                                    <span className="hour">{item.hour}</span>
                                    <p className="text">{item.text}</p>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}
